export enum NOTIFICATION_TYPE {
    MAINTENANCE = "Maintenance",
    INCIDENTS = "Incidents",
    SITE_ALERTS = "Site Alerts",
    GLOBAL_NOTIFICATIONS = "Global Notifications"
}